import { get } from "helper/request"
import cookie from "react-cookies"

export const loadAclPermissions = async () => {
    return get('/api/get_all_access_permissions/')
        .then(data => cookie.save('all_access_permissions', data['access_permissions']))
}

export const loadAclPermCategories = async () => {
    return get('/api/get_all_access_permission_categories/')
        .then(data => cookie.save('all_access_permission_categories', data['access_permission_categories']))
}


export const loadAccessPolicies = async () => {
    const organisation = cookie.load('organisation') || cookie.load('organisation_id')
    const url = encodeURI(`/api/get_all_access_policies/${organisation}/`)

    return get(url)
        .then(data => cookie.save('all_access_policies', data['all_access_policies']))
}

export const loadGroups = async () => {
    const organisation = cookie.load('organisation') || cookie.load('organisation_id')
    const url = encodeURI(`/api/get_all_groups/${organisation}/`)

    return get(url)
        .then(data => cookie.save('all_groups', data['all_groups']))
}

export const loadOrgs = async () => {
    const organisation = cookie.load('organisation') || cookie.load('organisation_id')
    const url = encodeURI(`/api/get_organisation_info/${organisation}/`)

    return get(url)
        .then(data => cookie.save('organisation', data?.name, { "path": "/" }))
}

export const loadOrgSetting = async () => {
    const organisationId = cookie.load('organisation_id')
    const url = encodeURI(`/api/get_organisation_setting/${organisationId}/`)

    return get(url)
    .then(data => cookie.save("organisation_setting", JSON.stringify(data["organisation_setting"]?.["config"]), { "path": "/" }))
}

export const loadDefaultPermissions = async () => {
    const url = encodeURI(`/api/get_default_access_permissions/`)

    return get(url)
        .then(data => cookie.save("default_access_permissions", JSON.stringify(data["default_access_permissions"]), { "path": "/" }))
}